import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowBoxLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowBoxLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3L12 3L12 5L5 5L5 19H12V21H3L3 3ZM15.5 6.08579L21.4142 12L15.5 17.9142L14.0858 16.5L17.5858 13H8V11H17.5858L14.0858 7.5L15.5 6.08579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowBoxLeft;
